module.exports = __webpack_public_path__ + "static/media/fixprice-step3.5e3ec058.png";